export var SideBarItemType={category:"category",product:"product",module:"module",submodule:"submodule",section:"section",operation:"operation",page:"page"};